import React from 'react'
import ApartmentList from '../marketingExecutive/ApartmentList'

const AddEditApartmentList = () => {
  return (
    <ApartmentList/>
  )
}

export default AddEditApartmentList
